import { compareStringsCaseDiacriticInsensitive } from "@/helpers/stringUtility";

import { IMilestoneTemplate } from "@/interfaces";

export const doesDuplicateMilestoneValueExists = (
  existingMilestoneTemplates: IMilestoneTemplate[],
  property: keyof IMilestoneTemplate,
  value: string,
  idOfMilestoneTemplateBeingEdited?: string
): boolean => {
  const idsAreNotEqual = (existingMilestoneTemplateId: string): boolean =>
    !idOfMilestoneTemplateBeingEdited ||
    existingMilestoneTemplateId !== idOfMilestoneTemplateBeingEdited;

  return existingMilestoneTemplates?.some((existingMilestoneTemplate) => {
    const propertyValue = existingMilestoneTemplate[property];
    return (
      compareStringsCaseDiacriticInsensitive(propertyValue, value) &&
      idsAreNotEqual(existingMilestoneTemplate.id)
    );
  });
};
